import React, { useEffect, useState } from 'react';

import { Box, Grid, Typography, useTheme } from '@mui/material';
import { motion } from 'framer-motion';

import parse from 'html-react-parser';
import { useTranslation } from 'react-i18next';
import StyledJadeSoftInterface from './styles';

import InterfaceGif from '../../../assets/video/interface.gif';
import MobileGif from '../../../assets/video/mobile.gif';

// const introductionText1 =
//   'Even though the employees are working hard <br/>if sales do not increase, <br/> there may be a problem with the "solution." <br/> <span className="bold">Just changing the solution can increase sales.</span>';

// const introductionText2 =
//   "We didn't start unless it was the best.<br/>We challenge the best of the system with 20 years of accumulated know-how.";

// const introductionText3 = 'Let me introduce <span>Jade Soft</span>';

const JadeSoftInterface = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const [changeOpacity, setChangeOpacity] = useState(false);
  const [isScrollSection, setIsScrollSection] = useState(false);
  const [dividerWidth, setDividerWidth] = useState(0); // Initial width (in %)

  const label = t('interface-content');
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const handleScroll = () => {
        const position = window.scrollY;

        // console.log(position);
        if (position >= 8950) {
          setIsScrollSection(true);
          // Map scroll percentage to a width range (10% to 100%)
          const documentHeight = document.documentElement.scrollHeight - window.innerHeight;
          const scrollPercent = ((position - 9000) / documentHeight) * 2000;
          const newWidth = Math.min(100, Math.max(10, scrollPercent + 10)); // Adjust range as needed
          setDividerWidth(newWidth);
          // setBackground(
          //   `rgb(${Math.round(newWidth) + 155}, ${Math.round(newWidth) + 155}, ${Math.round(newWidth) + 155})`,
          // );

          // console.log(documentHeight);
          // console.log(scrollPercent);
          // console.log(newWidth);
          // console.log(scrollYProgress);
        } else {
          setIsScrollSection(false);
          setDividerWidth(0);
          const documentHeight = document.documentElement.scrollHeight - window.innerHeight;
          const scrollPercent = ((position - 4500) / documentHeight) * 2000;
          const newWidth = Math.min(100, Math.max(10, scrollPercent + 10)); // Adjust range as needed
          // setBackground('rgb(155, 155, 155)');

          // setBackground(
          //   `rgb(${Math.round(scrollPercent) + 180}, ${Math.round(scrollPercent) + 180}, ${Math.round(scrollPercent) + 180})`,
          // );

          // console.log(documentHeight);
          // console.log(scrollPercent);
          // console.log(newWidth);
          // console.log(scrollYProgress);
        }
      };

      window.addEventListener('scroll', handleScroll);

      return () => window.removeEventListener('scroll', handleScroll);
    }
  }, [isScrollSection]);

  return (
    <StyledJadeSoftInterface>
      {/* <Box
        sx={{
          display: 'flex',
          // marginTop: '150px',
          // marginBottom: '150px',
          justifyContent: 'center',
          padding: '0 11%',
          width: '100%',
          background: '#fff',
        }}
      >
        <motion.div
          style={{
            height: '8px', 
            background: 'linear-gradient(90deg, #00FF00 0%, #01B762 50.44%, #017780 100%)',
            marginTop: '50px',
            borderRadius: '100px',
          }}
          animate={{ width: `${dividerWidth}%` }} 
          transition={{ duration: 0.5, ease: 'easeOut' }} 
        />
      </Box> */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', md: 'column', lg: 'row', xl: 'row' },
          alignItems: 'center',
          justifyContent: 'space-between',
          // minHeight: '100vh',
          backgroundColor: 'white',
          color: theme.palette.background.secondary,
          // paddingLeft: 20,
          // paddingRight: 10,
          // padding: '1% 6% 0 15%',
          padding: '1% 10% 0 8%',
          // paddingTop: 25,
          // paddingBottom: 0,
          [theme.breakpoints.down('lg')]: {
            px: 2,
            // py: 1,
          },
        }}
      // style={{ padding: '0 17.7%' }}
      >
        <Grid container rowSpacing={0} columnSpacing={{ xs: 0, sm: 0, md: 0, lg: 5, xl: 5 }}>
          {/* Left Content */}
          <Grid item xs={12} md={12} lg={7} xl={7} mt={20}
            sx={{
              [theme.breakpoints.down('lg')]: {
                mt: 10,
              },
            }}
          >
            {/* <Box sx={{ flex: 1, textAlign: { xs: 'center', md: 'left' }, zIndex: 1 }}> */}
            <motion.div
              initial={{
                opacity: 0,
                x: -100,
              }}
              whileInView={{
                opacity: 1,
                x: 0, // Slide in to its original position
                transition: {
                  duration: 1, // Animation duration
                },
              }}
            // viewport={{ once: true }}
            >
              <Box sx={{ display: { xs: 'none', sm: 'none', md: 'none', lg: 'flex', xl: 'flex' } }}>
                <img src={InterfaceGif} style={{ width: '550px', height: '345px' }} />
              </Box>
              <Box
                sx={{
                  display: { xs: 'flex', sm: 'flex', md: 'flex', lg: 'none', xl: 'none', justifyContent: 'center' },
                }}
              >
                <img src={InterfaceGif} style={{ width: '350px', height: '216.13px' }} />
              </Box>
              <Typography
                variant="body1"
                sx={{
                  mt: 3,
                  mb: 2,
                  ml: 5,
                  lineHeight: '47.73px',
                  wordWrap: 'break-word',
                  fontWeight: 800,
                  fontSize: '40px',
                  color: '#444444',
                  [theme.breakpoints.down('lg')]: {
                    fontSize: '30px',
                    fontWeight: 800,
                    lineHeight: '35.8px',
                    textAlign: 'center',
                    ml: 0,
                  },
                }}
              >
                {t('interface-title')}
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  ml: 5,
                  lineHeight: '23.87px',
                  // wordWrap: 'break-word',
                  fontWeight: localStorage.getItem('i18nextLng') === 'en-US' ? '500' : '700',
                  fontSize: '20px',
                  color: '#676767',
                  [theme.breakpoints.down('lg')]: {
                    fontSize: '18px',
                    fontWeight: localStorage.getItem('i18nextLng') === 'en-US' ? '500' : '600',
                    lineHeight: '23.4px',
                    textAlign: 'center',
                    ml: 0,
                  },
                }}
              >
                {parse(label)}
              </Typography>
            </motion.div>
          </Grid>
          {/* Right Content */}
          <Grid item xs={12} md={12} lg={5} xl={5}>
            <motion.div
              initial={{
                opacity: 0,
                x: 100,
              }}
              whileInView={{
                opacity: 1,
                x: 0, // Slide in to its original position
                transition: {
                  duration: 1, // Animation duration
                },
              }}
            // viewport={{ once: true }}
            >
              <Box
                sx={{
                  flex: 1,
                  display: { xs: 'none', sm: 'none', md: 'none', lg: 'flex', xl: 'flex' },
                  justifyContent: 'center',
                  alignItems: 'center',
                  position: 'relative',
                  // marginTop: -15,
                }}
              >
                {/* Replace with actual image */}
                <img
                  src={MobileGif}
                  alt="Jade Soft Graphics"
                  style={{
                    width: '924px',
                    height: '920px',
                    // maxWidth: '100%',
                    // height: '100%',
                    objectFit: 'cover',
                  }}
                />
              </Box>
            </motion.div>
            <Box
              sx={{
                flex: 1,
                display: { xs: 'flex', sm: 'flex', md: 'flex', lg: 'none', xl: 'none' },
                justifyContent: 'center',
                alignItems: 'center',
                position: 'relative',
                marginBottom: '-7px',
                // marginTop: -15,
              }}
            >
              {/* Replace with actual image */}
              <motion.div
                initial={{
                  opacity: 0,
                  x: 100,
                }}
                whileInView={{
                  opacity: 1,
                  x: 0, // Slide in to its original position
                  transition: {
                    duration: 1, // Animation duration
                  },
                }}
              // viewport={{ once: true }}
              >
                <img
                  src={MobileGif}
                  alt="Jade Soft Graphics"
                  style={{
                    width: '440px',
                    height: '410px',
                    // maxWidth: '100%',
                    // height: '100%',
                    objectFit: 'cover',
                  }}
                />
              </motion.div>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </StyledJadeSoftInterface>
  );
};

export default JadeSoftInterface;
